<template>
    <div class="model-files">

        <dropzone v-if="dropFiles" :url="url" :appends="payload" @success="success"></dropzone>

        <table class="table" v-if="showTable">
            <thead>
                <tr>
                    <th>Name</th>
                    <th width="20%">Uploaded At</th>
                    <th width="20%"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="file in files" :key="file.id">
                    <td v-text="file.name"></td>
                    <td v-text="shortDate(file.created_at)"></td>
                    <td>
                        <button  class="btn btn-blank btn-with-icon no-padding"
                                 @click="openModal(`delete-file-modal-${_uid}`); selectedFile = file"
                                 v-if="authorize('admin') || (isOwnerOfFile(file) && canDeleteFiles)">
                            <i class="fa fa-times text-danger"></i>
                        </button>
                        <button class="btn btn-blank btn-with-icon no-padding"
                                @click="openModal(`preview-file-modal-${_uid}`); selectedFile = file">
                            <i class="fa fa-eye text-muted"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <delete-file-modal :file="selectedFile" v-if="selectedFile && canDeleteFiles" @deleted="remove" :id="_uid"></delete-file-modal>
        <preview-file-modal :file="selectedFile" v-if="selectedFile" :id="_uid"></preview-file-modal>
    </div>
</template>
<script>
    export default {

        props: {
            model: {
                type: Object,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
            dropFiles: {
                type: Boolean,
                required: false,
                default: true,
            },
            payload: {
                type: Object,
                required: false,
                default: () => {
                }
            },
            canDeleteFiles: {
                type: Boolean,
                required: false,
                default: true,
            },
            showTable:{
                type: Boolean,
                required: false,
                default: true,
            }
        },

        data() {
            return {
                selectedFile: this.model.files.length ? this.model.files[0] : null,
                files: this.model.files,
            }
        },

        methods: {

            success(file) {
                this.files.push(file);
                if (!this.selectedFile) {
                    this.selectedFile = file;
                }
                this.$emit('uploaded', file);
            },

            remove(file) {
                var index = this.files.indexOf(file);
                this.files.splice(index, 1);
                this.$emit('removed', file);
            },

            isOwnerOfFile(file){
                return file.user.id == App.config.userId;
            }
        }
    }
</script>
